<template>
  <v-container fluid class="pa-6 qr-connection-page">
    <v-row justify="center">
      <v-col cols="12" md="7" lg="6" class="qr-grid">
        <v-card class="mb-4 status-card elevation-2" :class="statusColorClass">
          <v-card-text class="text-center white--text py-8 px-10">
            <div class="status-label mb-1">Status WhatsApp</div>
            <div class="status-value">{{ displayStatus }}</div>
            <div class="mt-6">
              <v-btn
                depressed
                color="white"
                class="black--text px-10 py-5 status-btn"
                :loading="statusLoading"
                @click="checkStatus"
              >
                Cek Status
              </v-btn>
            </div>
            <div v-if="showRestarting" class="d-flex align-center justify-center mt-6">
              <v-progress-circular size="18" width="2" color="white" indeterminate class="mr-2" />
              <span class="fs-16 font-italic font-weight-bold">Service restarting, mohon tunggu...</span>
            </div>
            <transition name="fade">
              <div v-if="feedback.message" class="mt-6 fs-16 font-weight-bold feedback-text">
                {{ feedback.message }}
              </div>
            </transition>
          </v-card-text>
        </v-card>

        <v-card class="qr-card elevation-2">
          <v-card-title class="justify-center font-weight-bold fs-18 text-uppercase">
            {{ statusNormalized === 'WORKING' ? 'Berhasil Terkoneksi' : 'QR CODE' }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text v-if="showQrImage">
            <div v-if="showQrImage" class="qr-wrapper">
              <v-img
                :src="qrImage"
                max-width="320"
                class="mx-auto pa-4 qr-image elevation-2"
                contain
              />
            </div>
            <div v-else-if="statusNormalized === 'SCAN_QR_CODE'" class="qr-wrapper">
              <v-progress-circular indeterminate color="primary" size="48" />
            </div>
            <div v-else class="text-center grey--text fs-12 py-8">
              QR hanya tersedia ketika status <strong>SCAN_QR_CODE</strong>.
              <br></br>
              Status saat ini adalah <strong>{{ statusNormalized === 'WORKING' ? 'CONNECTED' : statusNormalized }}</strong>.
            </div>
          </v-card-text>
          <v-card-text v-if="!showQrImage && statusNormalized !== 'WORKING'">
            <!-- <div class="text-center py-8 d-flex flex-column align-center">
              <v-progress-circular indeterminate color="primary" size="40" width="4" />
              <div class="mt-6 grey--text text--darken-1 fs-14 font-weight-medium">
                Mohon tunggu sebentar
              </div>
            </div> -->
            <v-img
             :src="require('@/assets/image/wait.png')"
             max-width="430"
             class="mx-auto pa-4 qr-image"
             contain
             />
          </v-card-text>
          <v-card-text v-if="statusNormalized === 'WORKING'">
            <v-img
             :src="require('@/assets/image/connected.png')"
             max-width="430"
             class="mx-auto pa-4 qr-image"
             contain
             />
             <!-- <div class="text-center grey--text fs-12 py-8">
              Status saat ini adalah <strong>{{ statusNormalized === 'WORKING' ? 'CONNECTED' : statusNormalized }}</strong>.
             </div> -->
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios"
import { get } from "@/service/Axios"

const WA_BASE_URL = "https://wa.ioi.web.id/api"
const DEFAULT_SESSION_NAME = "megavin"
const API_KEY_WA = "8752f0cc55ee4290a8d2d1382d34f9b6"
const STATUS_INTERVAL = 10000

export default {
  name: "QrImage",
  data() {
    return {
      statusRaw: "",
      statusLoading: false,
      qrImage: "",
      qrImageObject: null,
      statusIntervalId: null,
      feedback: {
        type: "",
        message: ""
      },
      sessionName: DEFAULT_SESSION_NAME
    }
  },
  computed: {
    activeSessionName() {
      return this.sessionName || DEFAULT_SESSION_NAME
    },
    statusNormalized() {
      return (this.statusRaw || "").toUpperCase()
    },
    displayStatus() {
      if (this.statusNormalized === "WORKING") return "CONNECTED"
      if (this.statusNormalized === "SCAN_QR_CODE") return "SCAN QR CODE"
      return this.statusNormalized || "-"
    },
    showRestarting() {
      return ["FAILED", "STARTING"].includes(this.statusNormalized)
    },
    showQrImage() {
      return this.statusNormalized === "SCAN_QR_CODE" && this.qrImage
    },
    statusColorClass() {
      const map = {
        FAILED: "status-failed",
        STARTING: "status-starting",
        SCAN_QR_CODE: "status-scan",
        WORKING: "status-connected",
        CONNECTED: "status-connected"
      }
      return map[this.statusNormalized] || "status-default"
    }
  },
  created() {
    this.fetchSessionConfig()
  },
  beforeDestroy() {
    this.clearStatusInterval()
    this.revokeQrImage()
  },
  methods: {
    async fetchSessionConfig() {
      try {
        const response = await get("admin/config", { params: {} })
        const session = response?.data?.results?.data?.[0]?.session
        if (session) {
          this.sessionName = session
        }
      } catch (error) {
        // Tetap gunakan default session jika config gagal dimuat
        console.error("Gagal mengambil konfigurasi WA:", error)
      } finally {
        this.checkStatus()
      }
    },
    async checkStatus(auto = false) {
      if (this.statusLoading && !auto) return
      this.statusLoading = true
      this.feedback.message = ""
        try {
          const { data } = await axios.get(`${WA_BASE_URL}/sessions/${this.activeSessionName}`, {
          headers: { "x-api-key": API_KEY_WA }
        })
        const status =
          data?.data?.state ||
          data?.state ||
          data?.status ||
          data?.session?.status ||
          ""
        this.statusRaw = status
        this.handleStatusFlow()
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Gagal cek status."
        this.setFeedback("error", message)
        this.clearStatusInterval()
      } finally {
        this.statusLoading = false
      }
    },
    handleStatusFlow() {
      const status = this.statusNormalized
      if (status === "FAILED") {
        this.logoutAndRetry()
        return
      }
      if (status === "STARTING") {
        this.scheduleStatusRetry()
        return
      }
      if (status === "SCAN_QR_CODE") {
        this.loadQrImage()
        this.startStatusInterval()
      } else {
        this.clearStatusInterval()
        this.revokeQrImage()
        this.qrImage = ""
      }
    },
    async logoutAndRetry() {
      try {
        await axios.post(
          `${WA_BASE_URL}/sessions/${this.activeSessionName}/logout`,
          {
            api_key: API_KEY_WA
          },
          {
            headers: {
              "x-api-key": API_KEY_WA,
              "Content-Type": "application/json"
            }
          }
        )
        this.setFeedback("info", "Logout berhasil, mencoba cek status ulang.")
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Logout gagal."
        this.setFeedback("error", message)
      } finally {
        setTimeout(() => this.checkStatus(true), 2000)
      }
    },
    scheduleStatusRetry() {
      this.clearStatusInterval()
      setTimeout(() => this.checkStatus(true), 3000)
    },
    startStatusInterval() {
      if (this.statusIntervalId) return
      this.statusIntervalId = setInterval(() => this.checkStatus(true), STATUS_INTERVAL)
    },
    clearStatusInterval() {
      if (this.statusIntervalId) {
        clearInterval(this.statusIntervalId)
        this.statusIntervalId = null
      }
    },
    async loadQrImage() {
      this.qrImage = ""
      this.revokeQrImage()
      try {
        const response = await axios.get(`${WA_BASE_URL}/screenshot`, {
          params: {
            session: this.activeSessionName
          },
          headers: {
            "x-api-key": API_KEY_WA
          },
          responseType: "blob"
        })
        const contentType =
          response?.data?.type ||
          response?.headers?.["content-type"] ||
          ""
        if (contentType.includes("application/json")) {
          const payload = JSON.parse(await response.data.text())
          const base64 =
            payload?.data?.qr ||
            payload?.data ||
            payload?.screenshot ||
            ""
          if (base64) {
            this.qrImage = base64.startsWith("data:image")
              ? base64
              : `data:image/png;base64,${base64}`
          }
        } else {
          this.qrImageObject = URL.createObjectURL(response.data)
          this.qrImage = this.qrImageObject
        }
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Gagal memuat QR."
        // this.setFeedback("error", message)
      }
    },
    revokeQrImage() {
      if (this.qrImageObject) {
        URL.revokeObjectURL(this.qrImageObject)
        this.qrImageObject = null
      }
    },
    setFeedback(type, message) {
      this.feedback = { type, message }
    }
  }
}
</script>

<style scoped>
.qr-connection-page {
  min-height: calc(100vh - 120px);
  background: #f5f7fb;
}

.qr-grid {
  display: flex;
  flex-direction: column;
  /* gap: 16px; */
}

.status-card {
  border-radius: 20px;
  transition: background 0.3s ease;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15) !important;
  position: relative;
  overflow: hidden;
}

.status-card::after {
  content: "";
  position: absolute;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  top: -50px;
  right: -80px;
}

.status-label {
  letter-spacing: 0.2em;
  font-size: 12px;
  opacity: 0.85;
}

.status-value {
  font-size: 40px;
  line-height: 1.2;
  font-weight: 700;
  text-transform: uppercase;
}

.status-btn {
  border-radius: 999px;
  font-weight: 600;
  letter-spacing: 0.08em;
}

.feedback-text {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  display: inline-block;
  padding: 8px 18px;
}

.status-failed {
  background: linear-gradient(135deg, #d50000, #ff5252);
}

.status-starting {
  background: linear-gradient(135deg, #ff6f00, #ffb74d);
}

.status-scan {
  background: linear-gradient(135deg, #2e7d32, #66bb6a);
}

.status-connected {
  background: linear-gradient(135deg, #1a237e, #42a5f5);
}

.status-default {
  background: linear-gradient(135deg, #424242, #757575);
}

.qr-card {
  border-radius: 24px;
  background: #fff;
  padding-bottom: 24px;
}

.qr-card .v-card__title {
  letter-spacing: 0.2em;
  color: #424242;
}

.qr-wrapper {
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-image {
  border-radius: 12px;
  background-color: #fff;
  border: 8px solid #fff;
}

@media (max-width: 960px) {
  .qr-grid {
    gap: 24px;
  }
  .status-value {
    font-size: 32px;
  }
}
</style>